import React from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import styles from "../sidequest.module.scss";

const videoBullets = [
  "See the dashboard from a developer's point of view",
  "Watch a real keyword tracking walkthrough",
  "Understand what verified access unlocks",
];

const Video = () => {
  return (
    <section className={`${styles.section} ${styles.videoSection}`} id="video">
      <div className={styles.container}>
        <div className={styles.videoStack}>
          <motion.div
            className={styles.videoInfo}
            initial={{ opacity: 0, x: -16 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
          >
            <span className={styles.badge}>See It In Action</span>
            <h2>Watch how KeyQuest works</h2>
            <p>
              A quick look at the tools you&apos;ll get access to as a
              verified Sidequest developer.
            </p>

            <div className={styles.registerBullets}>
              {videoBullets.map((bullet) => (
                <div key={bullet} className={styles.registerBullet}>
                  <CheckCircle size={16} />
                  {bullet}
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            className={styles.videoWrapper}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
          >
            <iframe
              src="https://www.youtube.com/embed/TscOxyJRt-k?autoplay=1&mute=1&loop=1&playlist=TscOxyJRt-k&rel=0"
              title="KeyQuest VR Intelligence"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Video;
